
<template lang="pug">
q-page.fit
  .q-pa-lg.column.items-center

    q-input.maintenance-entry-input.q-mt-md(
      v-model.trim="message"
      float-label="メッセージ"
    )

    q-input.maintenance-entry-input.q-mt-md(
      v-model="retrySeconds"
      type="number"
      float-label="リロード秒数 (0でリロード無効)"
    )

    q-input.maintenance-entry-input.q-mt-md(
      v-model.trim="allowIp"
      float-label="アクセス許可IP (カンマ区切りで複数指定可)"
    )

    q-btn.q-mt-lg(
      color="negative"
      @click="onClickDown"
    ) 上記パラメータでメンテナンスモード開始

    q-btn.q-mt-lg(
      color="warning"
      @click="onClickUp"
    ) メンテナンスモード停止

</template>

<script>
import {mapState, mapActions} from 'vuex'

import AxiosMixin from 'mixins/axios'

export default {
  mixins: [AxiosMixin],

  data() {
    return {
      message: '',
      retrySeconds: 0,
      allowIp: '',
    }
  },

  computed: {
    ...mapState(['status']),
  },

  async mounted() {
    try {
      const {data} = await this.axios.get('/api/maintenance-entry/view')
      this.allowIp = data.external_ip
    }
    catch(e) {this.$handler(e)}
  },

  methods: {
    ...mapActions(['fetchConfig']),

    async onClickDown() {
      try {
        await this.axios.put('/api/maintenance-entry/down', {
          message: this.message,
          retry: this.retrySeconds,
          allow: this.allowIp,
        })
        await this.fetchConfig()
      }
      catch(e) {this.$handler(e)}
    },

    async onClickUp() {
      try {
        await this.axios.put('/api/maintenance-entry/up')
        await this.fetchConfig()
      }
      catch(e) {this.$handler(e)}
    },

  },
}
</script>

<style lang="sass">
.maintenance-entry-input
  min-width: 400px
</style>
